import axios from 'axios';
import { Quote, QuoteDetails } from './types';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '',
});

// -----------------
// Salesforce Quotes
// -----------------

// Get all quotes
export async function getQuotes(): Promise<Quote[]> {
  const res = await api.get<Quote[]>('/api/salesforce/quotes');
  return res.data;
}

// Get quote details by ID
export async function getQuoteDetails(id: string): Promise<QuoteDetails> {
  const res = await api.get<QuoteDetails>(`/api/salesforce/quotes/${id}`);
  return res.data;
}
